/**
 * @namespace DeclineCookies
 * @memberof Promega.Shell
 * @description Methods for declining all cookies.
 */

import trackEvent from '../util/trackEvent';
import cookie from 'cookie_js';

const PROMEGA_COOKIE_POLICY = "promegaCookiePolicy";
const PROMEGA_COOKIE_POLICY_MAX_AGE = 3652;   // 10 years in days

const COOKIE_TYPE_N = 1;

/**
 * Sets promegaCookiePolicy with correct expiry and other
 * cookie properties
 */
function setPromegaCookie(cookieValue) {

    cookie.set(PROMEGA_COOKIE_POLICY, cookieValue, {
        expires: PROMEGA_COOKIE_POLICY_MAX_AGE,
        path: "/"
    });

    return cookieValue;
}

function hideCookieAlertBanner() {
    let cookieAlertBanner = document.getElementById("cookiepolicy");
    if (cookieAlertBanner) cookieAlertBanner.style.display = "none";
}

function cookieDeclineTriggerClicked(event) {
    if (event.target.classList.contains("trigger--decline-cookies-select")) {
        let newCookieValue = COOKIE_TYPE_N;
        setPromegaCookie(newCookieValue);
        Promega.Util.updateCookiePolicyConsent(newCookieValue);
        hideCookieAlertBanner();
        // trackEvent("Decline All", "Save", newCookieValue);
        event.preventDefault();
    }
}

// Init code
if (typeof document !== "undefined") {
    document.body.addEventListener("click", cookieDeclineTriggerClicked);
}